export const ACTIVE_STATUS = [
  {
    value: 1,
    label: 'Active',
    labelBn: 'সক্রিয়',
  },
  {
    value: 0,
    label: 'Inactive',
    labelBn: 'নিষ্ক্রিয়',
  },
]

export const SMS_STATUS = [
  { value: 'Delivered', label: 'Delivered', labelBn: 'ডেলিভার্ড' },
  { value: 'UnDelivered', label: 'Pending', labelBn: 'পেন্ডিং' },
  { value: 'Failed', label: 'Failed', labelBn: 'ফেইল্ড' },
]

export const SMS_SOURCE = [
  { value: 'Web', label: 'Web', labelBn: 'ওয়েব' },
  { value: 'API', label: 'API', labelBn: 'এপিআই' },
  { value: 'Others', label: 'Others', labelBn: 'আদার্স' },
]

export const SIDEBAR_MENU_ITEMS = [
  { key: 'admin', label: 'ADMIN', isTitle: true },
  {
    key: 'dashboards',
    icon: 'iconamoon:home-duotone',
    label: 'Dashboards',
    link: 'dashboard',
  },
  {
    key: 'Manage Organization',
    icon: 'ion:create-outline',
    label: 'Manage Organization',
    link: 'manage-organizations',
    collapsed: true,
    subMenu: [
      {
        key: 'ListOfOrgs',
        label: 'Organizations List',
        parentKey: 'menuitem',
        link: 'manage-organizations/org-list',
      },
    ],
  },
  {
    key: 'Manage User',
    icon: 'ion:create-outline',
    label: 'Manage User',
    link: 'manage-user',
    collapsed: true,
    subMenu: [
      {
        key: 'Register',
        label: 'Register',
        parentKey: 'menuitem',
        link: 'manage-user/register-user',
      },
      {
        key: 'ListOfUsers',
        label: 'Users List',
        parentKey: 'menuitem',
        link: 'manage-user/users-list',
      },
    ],
  },
  {
    key: 'Manage Package',
    icon: 'ion:create-outline',
    label: 'Manage Package',
    link: 'manage-package',
    collapsed: true,
    subMenu: [
      {
        key: 'package-expiration-logs',
        label: 'Package Expiration Logs',
        parentKey: 'menuitem',
        link: 'manage-packages/package-expiration-logs',
      },
      {
        key: 'Packages',
        label: 'Packages',
        parentKey: 'menuitem',
        link: 'manage-packages/packages',
      },
    ],
  },
  // {
  //   key: 'package-expiration-logs',
  //   icon: 'iconamoon:history-duotone',
  //   label: 'Package Expiration Logs',
  //   link: 'package-expiration-logs',
  // },
  {
    key: 'ip-whitelist',
    icon: 'iconamoon:shield-yes-duotone',
    label: 'IP Whitelist',
    link: 'ip-whitelist',
  },
]

export const USER_TYPE_OPTIONS = [
  { value: 'WALET', label: 'Wallet User', labelBn: 'ওয়ালেট ব্যবহারকারী' },
  {
    value: 'NON-WALET',
    label: 'Non-Wallet User',
    labelBn: 'নন-ওয়ালেট ব্যবহারকারী',
  },
]

export const CLIENT_TYPE_OPTIONS = [
  {
    value: 'INDIVIDUAL',
    label: 'Individual/Small Business',
    labelBn: 'ব্যক্তিগত/ছোট ব্যবসা',
  },
  { value: 'CORPORATE', label: 'Corporate', labelBn: 'কর্পোরেট' },
]

export const ROLE_OPTIONS = [
  {
    value: 'role-oid-00000001',
    label: 'SYSTEM_ADMIN',
  },
  { value: 'role-oid-00000002', label: 'MERCHANT' },
]

export const BILL_MSISDN_OPTIONS = [
  {
    value: 'setting-oid-00000001',
    label: '01552146079 - Teletalk',
  },
  {
    value: 'setting-oid-00000002',
    label: '01321170059 - Grameenphone',
  },
  {
    value: 'setting-oid-00000003',
    label: '01847343096 - Robi',
  },
  {
    value: 'setting-oid-00000004',
    label: '01969901070 - Banglalink (Non-Masking)',
  },
  {
    value: 'setting-oid-00000005',
    label: '01969901088 - Banglalink (Masking)',
  },
]

export const OPERATORS = [
  'Grameenphone',
  'Robi / Airtel',
  'Banglalink',
  'Teletalk',
]
